import json from './json'
import validate from './validate'
import load from './load'

export default {
  json: json,
  validate: validate,
  load: load,
}
